import Reveal from "@/components/Reveal";

const FOUNDER_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_the-literary-room/artifacts/mwgpao7l_image.png";

const paras = [
  "I created The Mahogany Room because I wanted somewhere else to go. And I mean that literally.",
  "I wanted a space for Black women that wasn't centered around the club, partying, being somebody's girlfriend, somebody's wife, somebody's mama, or constantly being everything for everybody else. Because we are so much more than that.",
  "We are women who read. Women who think. Women who are curious. Women who love getting dressed up for brunch and talking about a book that had us staring at the wall after the last chapter. We like beautiful spaces. We like laughing until our stomachs hurt. We like learning new things, having conversations that challenge us, meeting new women, trying new restaurants, traveling, getting cute, and simply enjoying ourselves.",
  "And sometimes I feel like Black women aren't given enough spaces to just be women.",
];

const affirmations = ["Not performing.", "Not taking care of everybody.", "Not being sexualized.", "Not being reduced to our bodies.", "Not being defined by who we belong to or who belongs to us.", "Just us."];

const paras2 = [
  "I wanted that for myself. I wanted something that gave me a reason to put my phone down, pick up a book, get out of the house, meet women I may have never crossed paths with otherwise, and have conversations about something other than men, work, kids, bills, and whatever life is currently throwing at us.",
  "And I figured I couldn't be the only Black woman craving that. So I created the room I wanted to walk into.",
  "The Mahogany Room is about books, absolutely. But the books are really the doorway. The heart of it is us.",
  "It's sitting around a table with Black women from different backgrounds, different ages, different experiences and different perspectives, and realizing how much we can learn from one another.",
];

const heartlines = [
  "It's sisterhood without pressure.",
  "It's getting dressed because the theme was too cute not to.",
  "It's arguing about a character like she's somebody we actually know.",
  "It's brunches, dinners, quiet reading nights, conversations, new experiences, and hopefully friendships that exist long after we close the book.",
];

const paras3 = [
  "I don't want The Mahogany Room to feel like something you simply joined. I want it to feel like somewhere you belong.",
  "Because Black women deserve spaces built around our minds, our softness, our curiosity, our joy and our stories too.",
  "So I made one.",
];

export const FoundersLetter = () => (
  <section className="py-28 bg-cream" data-testid="founders-letter" data-navbg="light">
    <div className="max-w-5xl mx-auto px-6">
      <Reveal className="text-center mb-16">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-fuchsia mb-4">A Letter From the Founder</p>
        <h2 className="font-serif text-4xl sm:text-6xl font-light text-mahogany-900 leading-tight">Why I Created<br />The Mahogany Room</h2>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="relative">
            <div className="absolute -inset-3 border border-gold/40 rounded-sm" />
            <img src={FOUNDER_IMG} alt="Jabrena, founder of The Mahogany Room" className="relative w-full rounded-sm object-cover aspect-[4/5] shadow-[0_20px_60px_rgba(75,31,23,0.25)]" />
          </div>
          <p className="font-script text-3xl text-fuchsia text-center mt-6">This is our room.</p>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-7">
          <div className="space-y-6 text-mahogany-800 text-lg leading-relaxed font-light">
            {paras.map((p) => <p key={p.slice(0, 28)}>{p}</p>)}

            <ul className="space-y-1.5 py-2 pl-5 border-l-2 border-gold/50">
              {affirmations.map((a) => (
                <li key={a} className={`font-serif text-xl ${a === "Just us." ? "text-fuchsia italic" : "text-mahogany-900"}`}>{a}</li>
              ))}
            </ul>

            {paras2.map((p) => <p key={p.slice(0, 28)}>{p}</p>)}

            <div className="space-y-1.5 py-2">
              {heartlines.map((h) => <p key={h.slice(0, 28)} className="font-serif text-xl text-mahogany-900 italic">{h}</p>)}
            </div>

            {paras3.map((p) => <p key={p.slice(0, 28)}>{p}</p>)}

            <div className="pt-6 border-t border-mahogany-700/15">
              <p className="font-serif text-3xl text-mahogany-900">Welcome to The Mahogany Room.</p>
              <p className="font-script text-4xl text-fuchsia mt-2">This is our room.</p>
              <p className="font-serif text-2xl text-mahogany-900 mt-6">— Jabrena</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FoundersLetter;
